import React from "react"
import { FormControl, InputLabel, Select, MenuItem, CircularProgress, Box, ListSubheader } from "@mui/material"
import { getPrinterLabel, getStoredFriendlyName } from "../../../utils/zebraPrinters"

export default function PrinterSelect({
  printers = [],
  selectedPrinterUid = "",
  onChange,
  loading = false,
  onRefresh,
  selectedPrinterMissing = false
}) {

  // Set new SelectedPrinterUid on printer new selection
  function handleChange(evt) {
    if (!onChange) return
    onChange(evt.target.value)
  }

  // The chosen printer stays displayed even when the search did not find it
  const showSelectedOutsideList = !!selectedPrinterUid && !printers.some(printer => printer?.uid === selectedPrinterUid)

  return (
    <FormControl variant="standard" sx={{ width: "100%" }}>
      <InputLabel>Imprimante</InputLabel>
      <Select
        variant="standard"
        name="printer"
        label="Imprimante"
        id="printer"
        value={selectedPrinterUid}
        onChange={handleChange}
        error={selectedPrinterMissing}
        MenuProps={{ PaperProps: { style: { maxHeight: 320 } } }}
      >
        <ListSubheader>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box>Imprimantes</Box>
            {/* Always available: every search has a time limit, so it cannot stay stuck */}
            <Box
              sx={{ cursor: "pointer", fontSize: 12, opacity: 0.8 }}
              onClick={function click() { if (onRefresh) onRefresh() }}
            >
              Actualiser
            </Box>
          </Box>
        </ListSubheader>

        {loading && (
          <MenuItem disabled>
            <Box display="flex" alignItems="center">
              <CircularProgress size={18} sx={{ mr: 1 }} />
              Recherche d'imprimantes…
            </Box>
          </MenuItem>
        )}

        {showSelectedOutsideList && (
          <MenuItem disabled value={selectedPrinterUid}>
            {getStoredFriendlyName(selectedPrinterUid) || selectedPrinterUid}{!loading && " (introuvable)"}
          </MenuItem>
        )}

        {printers.map(function(printer, i) {
          const key = printer && typeof printer.uid === "string" && printer.uid.length > 0 ? printer.uid : "idx_" + String(i)
          return (
            <MenuItem key={key} value={key}>
              {getPrinterLabel(printer) || "Imprimante inconnue"}
            </MenuItem>
          )
        })}

        {!loading && printers.length === 0 && (
          <MenuItem disabled>Aucune imprimante détectée</MenuItem>
        )}
      </Select>
    </FormControl>
  )
}
